import type { Middleware, UnknownAction } from '@reduxjs/toolkit';

type State = { auth: { accessToken: string | null; superAdminAccessToken: string | null } };
const principal = (token: string | null): unknown => {
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    // This is a cache partition, never an authorization decision. Refreshes keep the same partition.
    return [payload.strategy, payload.id, payload.companyId, payload.role, payload.aud];
  } catch {
    return 'invalid';
  }
};
const identity = ({ auth }: State) =>
  JSON.stringify([principal(auth.accessToken), principal(auth.superAdminAccessToken)]);

/** Native editors also cache company-from-JWT queries. Clear those when the principal changes. */
export const createIdentityCacheMiddleware =
  (resetActions: () => UnknownAction[]): Middleware<object, State> =>
  (api) =>
  (next) =>
  (action) => {
    const before = identity(api.getState());
    const result = next(action);
    if (before !== identity(api.getState()))
      for (const reset of resetActions()) api.dispatch(reset);
    return result;
  };
